import { format, isToday, isYesterday } from 'date-fns';

import { getDateLocalizations } from '../../core/utils/localization.ts';

/** The time of day only, "14:32". */
export const formatTime = (value: string | Date) => format(new Date(value), 'HH:mm');

type Translate = (key: string, options?: Record<string, unknown>) => string;

/** "Today, 14:05", "Yesterday" or "18 Aug 2026" — when a chat was last active, for the sidebar. */
export const formatRelativeDay = (value: string | null | undefined, t: Translate) => {
    if (!value) return '';
    const date = new Date(value);
    if (isToday(date)) return t('sidebar.todayAt', { time: formatTime(date) });
    if (isYesterday(date)) return t('sidebar.yesterday');
    return format(date, 'd MMM yyyy', { locale: getDateLocalizations() });
};
